import { z } from 'zod';
import { coordinateSchema } from '../../Shared.js';
import '../component/ComponentData.js';
import '../component/Page.js';
import '../component/items/index.js';
import { legacyCanvasDrawingSchema } from './LegacyCanvasDrawing.js';
import { entrySchema } from './items/index.js';
import { lineItemSchema } from '../component/items/Line.js';

const pageEntrySchema = z.object({
  id: z.string(),
  items: z.record(
    z.string(),
    z.object({
      position: coordinateSchema.optional(),
      zIndex: z.number().optional(),
      entry: entrySchema.optional()
    }).optional()
  ),
  clones: z.array(
    z.object({
      itemId: z.string(),
      cloneId: z.string(),
      entry: entrySchema.optional(),
      position: coordinateSchema,
      zIndex: z.number()
    })
  ),
  drawings: z.array(legacyCanvasDrawingSchema),
  lines: z.array(lineItemSchema)
});

export { pageEntrySchema };
//# sourceMappingURL=PageEntry.js.map
